import type { ReactNode } from "react";
import { TriangleAlert } from "lucide-react";

/** The red of what stops a purchase: the Link Editor's off-sale red. */
export const UNDELIVERABLE_RED = "#C62828";

/** Why a merch purchase cannot go on, in red after a warning sign: under the
 *  country it cannot be delivered to, and above Continue. */
export function Undeliverable({ children }: { children: ReactNode }) {
  return (
    <p
      role="note"
      style={{
        alignItems: "flex-start",
        color: UNDELIVERABLE_RED,
        display: "flex",
        fontSize: 13,
        gap: 6,
        lineHeight: 1.35,
        margin: 0,
      }}
    >
      <TriangleAlert
        aria-hidden="true"
        size={14}
        style={{ flexShrink: 0, marginTop: 2 }}
      />
      <span>{children}</span>
    </p>
  );
}
